import request from '@/utils/request'
import { getCookie } from '@/utils/cookie'

interface ITencentCaptcha {
  ret: number; //验证结果，0：验证成功。2：用户主动关闭验证码。
  ticket: string; //String	验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
  appid: string; //场景 ID。
  bizState: any; //自定义透传参数。
  randstr: string; //本次验证的随机串，请求后台接口时需带上
}

/**
 * 获取验证码
 */
export const getCaptcha = (data: AnyObject) => {
  return request({
    url: '/waic/account/console/captcha/get',
    data,
  })
}

/**
 * 登录
 */
export const login: Fetch<ILoginReq> = (data) => {
  let channelSource = getCookie('channel_source')
  if (data && channelSource) {
    data.loginSource = channelSource
  }
  const qhclickid = getCookie('qhclickid')
  if(data && channelSource && qhclickid){
    data.loginSource = `${channelSource}_${qhclickid}`
  }
  
  const bdVid = getCookie('bd_vid')
  if (data && bdVid) {
    channelSource || (channelSource = 'baidu')
    data.loginSource = `${channelSource}_${bdVid}`
  }
  if(data){
    data.loginUrl = window.location.href
  }
  return request({
    url: '/waic/account/console/login',
    data,
  })
}

/** 获取微信登录二维码 */
export const getWechatQRCode = () => {
  return request({
    url: '/waic/account/console/wx/qrcode/get',
  })
}

/**
 * 获取手机区号
 */
export const getZoneList: Fetch<{}, IRegion[]> = () => {
  return request({
    url: '/waic/account/console/zone/getList',
  })
}

/**
 * 获取用户当天登录次数
 */
export const getLoginCount: Fetch<{ mobileNo: string; zone: string }, number> = (data) => {
  return request({
    url: '/waic/account/console/captcha/count/get',
    data,
  })
}
export const captchaCheck: Fetch<any> = async (data) => {
  return request({
    url: '/waic/account/console/tencent/captcha/check',
    data,
  })
}
export const updateUserInfo = (data: any) => {
  return request({
    url: '/waic/account/user/info/update',
    data,
  })
}

export const graphicVerification = (): Promise<ITencentCaptcha> => {
  return new Promise((resolve, reject) => {
    const TencentCaptcha = (window as any).TencentCaptcha
    var captcha = new TencentCaptcha('196101942', function(res: any) {
      if (res.ret === 0) {
        resolve(res)
      } else {
        reject({})
      }
    })
    captcha.show() // 显示验证码
  })
}
export const bindWeChat = (ticket: string) => {
  return request({
    url: '/waic/account/user/channel/bind',
    data: {
      qrCodeTicket: ticket
    }
  })
}

export const bindMobile = (data: AnyObject) => {
  return request({
    url: '/waic/account/user/mobile/bind',
    data,
  })
}
